var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('OrientationTip',{attrs:{"showOrientationTip":_vm.showOrientationTip},on:{"closeTip":_vm.handleCloseTip}}),_c('router-view'),_c('FeedbackModal',{ref:"fbModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }